export default __webpack_public_path__ + "static/media/Jntuk-logo.8d7a7616.png";